<script lang="ts">
  import LanguageSwitcher from '../LanguageSwitcher.svelte';

  let { children } = $props();
</script>

<main class="mx-auto max-w-4xl rounded-lg bg-white p-4 shadow-md">
  {@render children()}

  <footer class="mt-auto p-2 text-sm">
    <div class="mx-auto flex max-w-7xl flex-col items-center justify-between sm:flex-row">
      <div>&copy; {new Date().getFullYear()} Linth Air Service</div>
      <div class="flex items-center gap-2">
        <LanguageSwitcher />
      </div>
    </div>
  </footer>
</main>
